export default __webpack_public_path__ + "81827b30e6e8edac5bebbc8504e2fe42.woff2";